import { render, staticRenderFns } from "./Distribuitors.vue?vue&type=template&id=1ec1208e&"
import script from "./Distribuitors.vue?vue&type=script&lang=js&"
export * from "./Distribuitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports